export default __webpack_public_path__ + "static/media/service_redemption.ffbf2f99.png";